import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './homepage.cssmodule.scss';
import NotificationWell from './NotificationWell';
import SearchBox from './SearchBox';
import IdeaBox from './IdeaBox'
import { Panel, FormControl, Button } from 'react-bootstrap';
import { injectIntl, intlShape, FormattedRelative } from 'react-intl';
import { Link } from 'react-router';


class HomePage extends React.Component {

  constructor(props) {
    super(props);
  }



  render() {
    const { summaryInfo } = this.props;
    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };
    const pendingTaskCount = summaryInfo.MyInitiativeCount + summaryInfo.MyCipCount + summaryInfo.RequireOpinionCount;
    return (
      <div className="container homepage-component" styleName="homepage-component">
        <div className="row">
          <div className="col-md-8" styleName="col-pad-top">
            <img className="img-responsive" src="/images/front-page-bg.jpg" alt="" />
            <div styleName="welcome-text">
              <h3 styleName="header">{t('WELCOME')}<br />{t('APP_NAME')}</h3>
              <p styleName="content">
                {t('APP_BANNER_DESC')}
              </p>
            </div>
          </div>
          <div className="col-md-4" styleName="col-pad-top">
            <SearchBox></SearchBox>

            <Panel header={t('APPLICATION MANUAL')} className="brand-panel">
              <a href={t('MANUAL_URL')} >{t('How to use this application')}&nbsp;<img src="/images/powerpoint.png"></img></a>
            </Panel>
          </div>
        </div>
        <div className="row">
          <div className="col-md-8"></div>
          <div className="col-md-4">
            <Panel header={t('LINKS_HEADER')} className="brand-panel">
              < a target="_blank" href="https://app.powerbi.com/groups/me/apps/6d6861d6-3801-4956-a9be-13922046bf2c/reports/529ca338-781d-4fd5-a43e-e505f4ec7c64/ReportSection">{t('FOCUS_INDICATORS')}</a>
            </Panel>
          </div>
        </div>
        <hr />
        {
          pendingTaskCount > 0 && <NotificationWell hasInitiative={summaryInfo.MyInitiativeCount || summaryInfo.RequireOpinionCount} hasCIP={summaryInfo.MyCipCount}>
            {
              <div>
                <div>{t('TASK_WARNING', { value: pendingTaskCount })}</div>
                <div style={{ display: 'grid' }}>
                  {(summaryInfo.MyInitiativeCount > 0) &&
                    <strong>
                      <Link style={{ color: '#a94442' }} to='/manage-ideas/1'>{t('INITIATIVE_WARNING', { value: summaryInfo.MyInitiativeCount })}</Link>
                    </strong>
                  }
                  {(summaryInfo.MyCipCount > 0) &&
                    <strong>
                      <Link style={{ color: '#a94442' }} to='/manage-ideas/2'>{t('IDEAS_WARNING', { value: summaryInfo.MyCipCount })}</Link>
                    </strong>
                  }
                  {summaryInfo.RequireOpinionCount > 0 &&
                    <strong>
                      <Link style={{ color: '#a94442' }} to='/manage-ideas/1'>{t('OPINION_WARNING', { value: summaryInfo.RequireOpinionCount })}</Link>
                    </strong>
                  }
                </div>
              </div>
            }
          </NotificationWell>
        }

        <div className="row">
          <div className="col-md-6">
            <IdeaBox browseUrl="/browse-ideas/1" browseTitle={t('Browse Initiatives')} buttonTitle={t('CREATE INITIATIVE')} buttonIcon="/images/ideas.png" to="/ideas/1" count={summaryInfo.YearlyInitiativeCount} unit={t('initiative(s)')} description={t('INITIATIVE_DESC')}></IdeaBox>
          </div>
          <div className="col-md-6">
            <IdeaBox browseUrl="/browse-ideas/2" browseTitle={t('Browse CI-Proposals')} buttonTitle={t('CREATE CONTINUOUS IMPROVEMENT')} buttonIcon="/images/cip.png" count={summaryInfo.YearlyCipCount} unit={t('CIP')} to="/ideas/2" description={t('CIP_DESC')}></IdeaBox>
          </div>
        </div>

      </div>
    );
  }
}

HomePage.displayName = 'HomePage';
HomePage.propTypes = {};
HomePage.defaultProps = {};


export default injectIntl(cssmodules((HomePage), styles));




// WEBPACK FOOTER //
// ./components/Home/HomePage.js